import { NgModule } from '@angular/core';
import { LibChevronMoreIconComponent } from './lib-chevron-more-icon.component';

@NgModule({
  declarations: [LibChevronMoreIconComponent],
  exports: [LibChevronMoreIconComponent],
})
export class LibChevronMoreIconModule {}
